module.exports = __webpack_public_path__ + "static/media/06.3313a14c.jpg";